$(".burger").click(function () {
    $(".header").toggleClass("_open")
    $("body").toggleClass("fixed-body")
})

$("._toggle-search").click(function () {
    $(".header-search").toggleClass("_open")
})

$(".nav__sub-link").click(function () {
    let id = $(this).attr("data-id")
    $(".catalog").find(`[data-tab='_tab${id}']`).click()
    $(".header").removeClass("_open")
    $("body").removeClass("fixed-body")
})

$(".nav__link").click(function () {
    $(".header").removeClass("_open")
    $("body").removeClass("fixed-body")
})
